import script from "./musiques.vue?vue&type=script&setup=true&lang=js"
export * from "./musiques.vue?vue&type=script&setup=true&lang=js"

import "./musiques.vue?vue&type=style&index=0&id=05f0f056&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f0f056"]])

export default __exports__